import * as React from "react";
const SvgEmptyCheckbox = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 22, height: 22, x: 1, y: 1, fill: "none", fillRule: "evenodd", stroke: "#8A8A8A", strokeWidth: 2, rx: 4 }));
export default SvgEmptyCheckbox;
